import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import SvgIcon from "../svg-icons/SvgIcon";
import SvgIcon2 from "../svg-icons/SvgIcon2";
import * as stylex from '@stylexjs/stylex';
export default function Icon(props) {
  var _props$style, _extracted_size_fr_fo, _props$icon$split, _props$size, _props$color, _props$style2, _props$className, _stylex$props, _props$color2;
  var extracted_size_fr_font_size = (_props$style = props.style) === null || _props$style === void 0 || (_props$style = _props$style.fontSize) === null || _props$style === void 0 || (_props$style = _props$style.toString()) === null || _props$style === void 0 ? void 0 : _props$style.replace("px", "");
  if (((_extracted_size_fr_fo = extracted_size_fr_font_size) === null || _extracted_size_fr_fo === void 0 || (_extracted_size_fr_fo = _extracted_size_fr_fo.toString()) === null || _extracted_size_fr_fo === void 0 || (_extracted_size_fr_fo = _extracted_size_fr_fo.trim()) === null || _extracted_size_fr_fo === void 0 ? void 0 : _extracted_size_fr_fo.length) > 0) {
    extracted_size_fr_font_size = Number(extracted_size_fr_font_size);
  }
  var _useState = useState(props.animated ? 0 : props.size),
    _useState2 = _slicedToArray(_useState, 2),
    fontSize = _useState2[0],
    setFontSize = _useState2[1];
  useEffect(function () {
    setTimeout(function () {
      setFontSize(props.size);
    }, 100);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.icon && props.icon.indexOf("svg\.") > -1 && /*#__PURE__*/React.createElement(SvgIcon, {
    icon: (_props$icon$split = props.icon.split(".")) === null || _props$icon$split === void 0 ? void 0 : _props$icon$split[1]
  }), props.icon && props.icon.indexOf("svg2.") > -1 && /*#__PURE__*/React.createElement(SvgIcon2, _extends({
    path: props.icon,
    size: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : extracted_size_fr_font_size,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : (_props$style2 = props.style) === null || _props$style2 === void 0 || (_props$style2 = _props$style2.color) === null || _props$style2 === void 0 ? void 0 : _props$style2.toString()
  }, props)), props.icon && !props.icon.match(/^svg2?\./) && /*#__PURE__*/React.createElement("i", {
    className: ["feather", "feather-".concat(props.icon), (_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : '', (_stylex$props = stylex.props(ui.base, props.stylexStyles)) === null || _stylex$props === void 0 ? void 0 : _stylex$props.className].join(' '),
    style: props.useStyle === void 0 || props.useStyle ? _objectSpread({
      fontSize: "".concat(fontSize, "px"),
      color: "".concat((_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : undefined),
      transition: 'font-size 0.1s cubic-bezier(.23, 1.03, .67, .99)'
    }, props.style) : {}
  }));
}
Icon.defaultProps = {
  size: 15,
  animated: false
};

// @ts-ignore
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
var ui = {
  base: {
    "Icon__ui.base": "Icon__ui.base",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  }
};